import { defineStore } from "pinia";
import axios from "axios";

export const useDisaterRequestStore = defineStore("disater", {
  state: () => ({}),

  actions: {
    async postDiasater(payload, id = null) {
      try {
        const url = id ? `/post/${id}` : "/post";
        const res = await axios.post(url, payload);
        if (res.status === 200 || res.status === 201) return res.data;
        throw new Error(`Unexpected status: ${res.status}`);
      } catch (error) {
        const msg =
          error?.response?.data?.message || error.message || "request failed";
        console.error("POST ERROR:", msg);
        throw new Error(msg);
      }
    },

    async getDiasater(query) {
      try {
        const response = await axios.get("/posts", { params: query });
        if (response.status === 200 || response.status === 201) {
          // console.log("GET :", response.data);
          return response.data;
        }
      } catch (error) {
        console.error("GET ERR :", error);
        throw error;
      }
    },

    async getByIdDisater(id) {
      try {
        const response = await axios.get(`/posts/${id}`);
        if (response.status === 200 || response.status === 201) {
          // console.log("GET :", response.data);
          return response.data;
        }
      } catch (error) {
        console.error("GET ID ERR :", error);
        throw error;
      }
    },

    async getShelterDashboard(query) {
      try {
        const response = await axios.get(`/shelter-dashboard`, {
          params: query,
        });
        if (response.status === 200 || response.status === 201) {
          // console.log("GET :", response.data);
          return response.data;
        }
      } catch (error) {
        console.error("GET ERR :", error);
        throw error;
      }
    },

    async getDisaterLog(query) {
      try {
        const response = await axios.get(`/post-logs`, { params: query });
        if (response.status === 200) {
          // console.log(`GET :`, response.data);
          return response.data;
        }
      } catch (error) {
        console.error(`GET ERROR:`, error);
        throw error;
      }
    },

    async exportData(type, filter = {}) {
      try {
        console.log(filter);
        const params = new URLSearchParams({ disaster: type, ...filter });
        const url = `${axios.defaults.baseURL}/export-disaster?${params.toString()}`;
        const response = await fetch(url, {
          method: "GET",
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        let filename = `${type} file`;
        const link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
  },
});
